// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Caml_format from "../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as CsvValidator from "../view/library/CsvValidator.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as CsvHelper$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/csv-parser/CsvHelper.bs.js";
import * as ArrayUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ArrayUtils.bs.js";
import * as FlatResult$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/reasonML/FlatResult.bs.js";
import * as ReMapUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReMapUtils.bs.js";
import * as BulkUploadTransactionsSchema from "./BulkUploadTransactionsSchema.bs.js";
import * as BulkUploadPartnerRequestCsvResultMapper from "./BulkUploadPartnerRequestCsvResultMapper.bs.js";

function validateDateString(dateString) {
  if (DateTime$Catalyst.isValid(DateTime$Catalyst.fromString("ddmmyyyy", dateString))) {
    return {
            TAG: /* Ok */0,
            _0: dateString
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Invalid date in filename"
          };
  }
}

function validateFileIndexFileName(index) {
  try {
    Caml_format.caml_int_of_string(index);
    return {
            TAG: /* Ok */0,
            _0: index
          };
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "Invalid index number in filename"
          };
  }
}

function validateFileName(fileName) {
  var fileNameContents = $$Array.to_list(Caml_array.get(fileName.split("."), 0).split("_"));
  if (!fileNameContents) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: "Please name the file in this format <Name>_<ddmmyyyy>_<integer>"
            }
          };
  }
  var match = fileNameContents.tl;
  if (!match) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: "Please name the file in this format <Name>_<ddmmyyyy>_<integer>"
            }
          };
  }
  var match$1 = match.tl;
  if (!match$1) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: "Please name the file in this format <Name>_<ddmmyyyy>_<integer>"
            }
          };
  }
  if (match$1.tl) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: "Please name the file in this format <Name>_<ddmmyyyy>_<integer>"
            }
          };
  }
  var _dateStr = validateDateString(match.hd);
  if (_dateStr.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: _dateStr._0
            }
          };
  }
  var _indexStr = validateFileIndexFileName(match$1.hd);
  if (_indexStr.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: fileName
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: _indexStr._0
            }
          };
  }
}

function checkDulicateMsisdns(rowsResults) {
  return List.fold_right((function (row, param) {
                  var checkMap = param[1];
                  var result = param[0];
                  if (row.TAG !== /* Ok */0) {
                    return [
                            {
                              hd: {
                                TAG: /* Error */1,
                                _0: row._0
                              },
                              tl: result
                            },
                            checkMap
                          ];
                  }
                  var request = row._0;
                  var match = Curry._2(ReMapUtils$Catalyst.StringMap.exists, (function (key, _value) {
                          return request.driver_msisdn === key;
                        }), checkMap);
                  if (match) {
                    return [
                            {
                              hd: {
                                TAG: /* Error */1,
                                _0: "duplicate entry"
                              },
                              tl: result
                            },
                            checkMap
                          ];
                  } else {
                    return [
                            {
                              hd: {
                                TAG: /* Ok */0,
                                _0: request
                              },
                              tl: result
                            },
                            Curry._3(ReMapUtils$Catalyst.StringMap.add, request.driver_msisdn, "", checkMap)
                          ];
                  }
                }), rowsResults, [
                /* [] */0,
                ReMapUtils$Catalyst.StringMap.empty
              ])[0];
}

function getValidRecords(recordResults) {
  return List.fold_left((function (result, recordResult) {
                if (recordResult.TAG === /* Ok */0) {
                  if (result.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: Pervasives.$at(result._0, {
                                  hd: recordResult._0,
                                  tl: /* [] */0
                                })
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: $$Array.append(result._0, [undefined])
                          };
                  }
                }
                var error = recordResult._0;
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: $$Array.append(Caml_array.make(List.length(result._0), undefined), [error])
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: $$Array.append(result._0, [error])
                        };
                }
              }), {
              TAG: /* Ok */0,
              _0: /* [] */0
            }, recordResults);
}

function validateCsvResult(csvResult, schema, bulkUploadPartnerRequestCsvResultMapper, country) {
  var data = CsvValidator.validateCsvResult(csvResult, schema, bulkUploadPartnerRequestCsvResultMapper, country);
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: data._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: data._0
            }
          };
  }
}

function validateCSVFileType(fileInput) {
  var fileType = fileInput.type;
  var _fileExtn = CsvHelper$Catalyst.isFileExtensionValid(fileType);
  if (_fileExtn.TAG === /* Ok */0 || fileInput.name.endsWith(".csv")) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: "Upload File has to be of .csv format only"
            }
          };
  }
}

function getHeader(rows) {
  var header = CsvHelper$Catalyst.getHeaderRow(rows);
  if (header.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: header._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* OtherError */1,
              _0: header._0
            }
          };
  }
}

function validate(csvResult, fileInput, country) {
  return FlatResult$Catalyst.let_(validateCSVFileType(fileInput), (function (_fileExtension) {
                return FlatResult$Catalyst.let_(validateFileName(fileInput.name), (function (_fileNameResult) {
                              var schema = BulkUploadTransactionsSchema.getSchema(undefined);
                              var columnCount = List.length(Curry._1(ReMapUtils$Catalyst.StringMap.bindings, schema));
                              return FlatResult$Catalyst.let_(validateCsvResult(csvResult, schema, BulkUploadPartnerRequestCsvResultMapper.map, country), (function (validatedResult) {
                                            var rowsWithDuplicatesMarked = checkDulicateMsisdns(validatedResult);
                                            var recordList = getValidRecords(rowsWithDuplicatesMarked);
                                            if (recordList.TAG === /* Ok */0) {
                                              return {
                                                      TAG: /* Ok */0,
                                                      _0: recordList._0
                                                    };
                                            }
                                            var errorArray = recordList._0;
                                            var csvRowsArray = csvResult.data;
                                            return FlatResult$Catalyst.let_(getHeader(csvRowsArray), (function (header) {
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    TAG: /* ErrorRows */0,
                                                                    _0: header,
                                                                    _1: $$Array.mapi((function (idx, error) {
                                                                            if (error !== undefined) {
                                                                              return $$Array.append(ArrayUtils$Catalyst.firstN(columnCount, Caml_array.get(csvRowsArray, idx + 1 | 0)), [error]);
                                                                            } else {
                                                                              return Caml_array.get(csvRowsArray, idx + 1 | 0);
                                                                            }
                                                                          }), errorArray)
                                                                  }
                                                                };
                                                        }));
                                          }));
                            }));
              }));
}

export {
  validate ,
  
}
/* CsvValidator Not a pure module */
